module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_0_0.1681c0e2.png";